import { useRef } from 'react';
import Player from '../../../../../components/3catinfo/Player';
import clsx from 'clsx';
import styles from '../cosNoticia.module.scss';

const Video = (props) => {
    const { id } = props;
    const playerRef = useRef();

    const stylesMedia = clsx({
        [styles.media]: true,
        [styles.mediaVideo]: true
    });

    if (id) {
        return (
            <div className={stylesMedia} data-testid='cos-noticia-media-video'>
                {id && <Player id={id} estils='noticia' ref={playerRef} playerVideoTagId={`video-noticia-${id}`} />}
            </div>
        );
    }
    return null;
};

export default Video;
